import {
    DocumentMedium,
    PinMedium,
    PriceMedium,
    PropertyManagementMedium,
    AnnouncementMedium,
    BarChartUpwardMedium
} from '@zoopla-eng/zds-components/icons';
import { NotificationTypeValues } from '../../../graphql.generated';
import { ReactElement } from 'react';
import { notificationIconContainerStyle } from './NotificationIcon.styles.css';

type Color = 'purple' | 'blue' | 'brown' | 'maroon' | 'yellow' | 'pink';

const ICONS: Record<
    NotificationTypeValues,
    { icon: ReactElement; color: Color; testId: string }
> = {
    HOME_ESTIMATE_CHANGED: {
        icon: <PriceMedium accessibilityType="decorative" />,
        color: 'purple',
        testId: 'home_estimate_changed_icon'
    },
    NEW_SIMILAR_CHANGED: {
        icon: <PinMedium accessibilityType="decorative" />,
        color: 'blue',
        testId: 'new_similar_listings_icon'
    },
    LOCAL_MARKET_UPDATE: {
        icon: <PropertyManagementMedium accessibilityType="decorative" />,
        color: 'brown',
        testId: 'local_market_update_icon'
    },
    NEW_SOLD_PROPERTIES: {
        icon: <PinMedium accessibilityType="decorative" />,
        color: 'blue',
        testId: 'new_sold_properties_icon'
    },
    NEW_RELATED_ARTICLE: {
        icon: <DocumentMedium accessibilityType="decorative" />,
        color: 'maroon',
        testId: 'new_related_article_icon'
    },
    PLANNING_APPLICATION: {
        icon: <DocumentMedium accessibilityType="decorative" />,
        color: 'yellow',
        testId: 'planning_application_icon'
    },
    GET_MORTGAGE: {
        icon: <BarChartUpwardMedium accessibilityType="decorative" />,
        color: 'pink',
        testId: 'mortgage_icon'
    }
};

export const NotificationIcon = ({
    notificationType
}: {
    notificationType: NotificationTypeValues;
}) => {
    const { icon, color, testId } = ICONS[notificationType] || {
        icon: <AnnouncementMedium accessibilityType="decorative" />,
        color: 'purple',
        testId: 'default_notification_icon'
    };

    return (
        <div
            className={notificationIconContainerStyle({ iconColor: color })}
            data-testid={testId}
        >
            {icon}
        </div>
    );
};
